<mat-chip-grid #chipList [required]="required" [disabled]="disabled">
  @for (val of value; track val) {
  <mat-chip-row [removable]="true" (removed)="remove(val)">
    {{
      val.length > maxValueLength
        ? val.substr(0, maxValueLength - 1) + '&hellip;'
        : val
    }}
    @if (validTest(val)) {
    <mat-icon
      class="material-icons-outlined chip-info-icon"
      matChipAvatar
      color="accent"
      >info
    </mat-icon>
    } @if (!validTest(val)) {
    <mat-icon
      class="material-icons-outlined chip-warning-icon"
      matChipAvatar
      color="warn"
    >
      warning
    </mat-icon>
    }
    <mat-icon matChipRemove>clear</mat-icon>
  </mat-chip-row>
  }
  <input
    #inputElement
    [(ngModel)]="emailInputValue"
    #emailInputControl="ngModel"
    [placeholder]="placeholder"
    [matChipInputFor]="chipList"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputAddOnBlur]="true"
    (blur)="handleOnTouched()"
    (matChipInputTokenEnd)="add($event)"
    [email]="true"
    (paste)="paste($event)"
  />
</mat-chip-grid>
